import React from 'react';
import './Notification.css';

function Notification({ variant = 'default', messages }) {
  const defaultMessages = [
    'Applications are invited from Bachelor of Naturopathy and Yogic Sciences (BNYS) Graduates from any UGC recognised Universities for Central Registration and Kindly note NRB is also Issuing certificate for those who have already registered with Central Council of Research in Yoga and Naturopathy (CCRYN), New Delhi.',
    'It has been known that some individuals are canvassing people to get Naturopathy Registration Board Certificate for Degree/ Diploma/ Certificate Holder in Naturopathy. Public are hereby instructed not to get deceived with such touting individuals and not to make any payments. At present, Naturopathy Registration Board (NRB) is providing registration to BNYS graduates only and payments are made only through NRB portal. NRB has not authorized anybody for making payment.',
    'State registration is mandatory under the NRB–HPR integrated registration process. All concerned practitioners are requested to download their HPR Certificate and ID Card from the HPR Portal using the link: https://nhpr.abdm.gov.in/nhpr/v4/login'
  ];

  const activeMessages = messages || defaultMessages;
  const isDanger = variant === 'danger';

  const renderMessage = (text) => {
    const parts = text.split(/(https?:\/\/[^\s]+)/g);

    return parts.map((part, index) => {
      if (/^https?:\/\//.test(part)) {
        return (
          <a
            key={`${part}-${index}`}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            className="marquee-link"
          >
            {part}
          </a>
        );
      }

      return <React.Fragment key={`${part}-${index}`}>{part}</React.Fragment>;
    });
  };

  return (
    <div className={`notification-container ${isDanger ? 'notification-danger' : ''}`}>
      <span className={`notification-badge ${isDanger ? 'notification-badge-danger' : ''}`}>
        {isDanger ? '⚠️' : '📢'}
      </span>
      <div className="marquee-wrapper">
        <div className="marquee">
          {activeMessages.map((message, index) => (
            <React.Fragment key={index}>
              <span className="marquee-text">{renderMessage(message)}</span>
              {index < activeMessages.length - 1 && <span className="marquee-divider">◆</span>}
            </React.Fragment>
          ))}
          {activeMessages.map((message, index) => (
            <React.Fragment key={`repeat-${index}`}>
              <span className="marquee-text">{renderMessage(message)}</span>
              {index < activeMessages.length - 1 && <span className="marquee-divider">◆</span>}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Notification;

